// extracted by mini-css-extract-plugin
module.exports = {"fromItem":"_1rLmk","signUp":"_3JmKB","jumpToLogin":"OMn1o","mantle":"_1DMc3","extra":"VZnB5","container":"_1Y3sF","box":"_33PFF","previous_page":"_3sE8f","boxCon":"_1nAH_"};